import { graphql } from "@/graphql/codegen"

import "./payFile.fragment"

graphql(`
  query GetPayFileList($input: PayFileListInput!) {
    payFile {
      list(input: $input) {
        __typename
        ... on PayFileListSuccess {
          payFiles {
            ...PayFileListFields
          }
        }
        ... on PayFileListFailure {
          error {
            message
          }
        }
      }
    }
  }
`)
